import { VStack } from 'ui_2';
import { Level } from './Level';
import { Waterings } from './Waterings';
import { GrowthRewards } from './GrowthRewards';

export const Stats = () => {
  return (
    <VStack className='w-full items-center'>
      <Level />
      <Waterings />
      <GrowthRewards />
    </VStack>
  );
};
